"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  toolboxContainer: {
    fontSize: '1rem',
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: '#fff',
    padding: 10
  },
  toolboxRow: {
    '& label': {
      display: 'flex',
      alignItems: 'center'
    }
  }
};